import './styles/globals.css';
import './i18n';
import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './router';

export const createRoot = ViteReactSSG({ routes });
